import { createFeatureSelector, createSelector } from "@ngrx/store";
import { errorFeatureKey, ErrorState } from "./error.reducer";

export const getErrorMsgFeature = createFeatureSelector<ErrorState>(errorFeatureKey);

export const getErrorMsg = createSelector(getErrorMsgFeature, (state) => state.errorMsg);
export const getKioskError = createSelector(getErrorMsgFeature, (state) => state.kioskError);
export const getShowErrorPage = createSelector(getErrorMsgFeature, (state) => state.errorMsg !== undefined);
export const getErrorLevel = createSelector(getErrorMsgFeature, (state) => state.errorLevel);
